"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js");
require("./extensions/globals");
require("./extensions/angular");
var book_1 = require("./book/book");
var config_1 = require("./book/config");
var store_1 = require("./book/store");
if ($('pb-app').length) {
    config_1.default.load().then(function (config) {
        book_1.default.constant('config', config);
        var href = config.params.base + 'books/' + config.params.book + '/config.css';
        $('head').append($('<link rel="stylesheet" href="' + href + '" media="all" charset="utf-8" />'));
        var $root = document.querySelector('pb-app');
        angular.bootstrap($root, ['pb'], { strictDi: config.params.strictDi });
    });
}
var ApplicationState = /** @class */ (function () {
    function ApplicationState() {
        this.currentPage = null;
        this.navigated = false;
        this.saved = true;
        this.externalButton = false;
        this.basketEnabled = false;
        this.debug = false;
        this.screen = {
            touch: false
        };
    }
    return ApplicationState;
}());
exports.ApplicationState = ApplicationState;
function ApplicationDirective($q, $timeout, $interpolate, $templateCache, config, book, tabNav, dialog, resizer, scroller, touchDetector, testFeatures, externalButton, send, track, appState) {
    return {
        templateUrl: config.params.base + 'templates/application.html',
        link: function (scope, element, attr, app) {
            scope.element = element;
            scope.resizeCallback = function (screen) {
                $timeout(function () {
                    Object.assign(appState.screen, screen);
                });
            };
            scope.touchCallback = function (touch) {
                $timeout(function () {
                    appState.screen.touch = touch;
                });
            };
            resizer.init(element, config.preview.meta.sizes, scope.resizeCallback);
            scroller.init(element, function () { });
            touchDetector.init(element, scope.touchCallback);
        },
        controller: /** @class */ (function () {
            function AppController($scope, preview, formValidator, testFeatures, profanityFilter) {
                var _this = this;
                this.$scope = $scope;
                this.preview = preview;
                this.formValidator = formValidator;
                this.testFeatures = testFeatures;
                this.profanityFilter = profanityFilter;
                this.validated = [];
                this.store = new store_1.default();
                this.autoForms = 0;
                appState.appCtrl = this;
                this.state = appState;
                this.state.debug = config.params.debug || false;
                this.book = book;
                this.tabNav = tabNav;
                this.locale = { ui: Object.assign({}, config.localeJson.ui) };
                this.lang = { ui: config.params.langUI, book: config.params.langBook };
                this.autoForms = this.countAutoForms();
                this.state.book = config.configJson.id;
                this.state.existentConfig = config.importJson !== undefined;
                this.state.navigated = this.state.existentConfig;
                this.state.basketEnabled = this.state.existentConfig;
                this.state.profanityFilter = config.configJson.profanityFilter !== false;
                this.state.fullPreview = config.configJson.preview.meta.fullPreview && !this.hasFeature('fullPreviewOff');
                this.state.screen.fullPreview = false;
                this.state.sendMail = !!config.configJson.preview.meta.export;
                this.state.loaderAnimation = false;
                this.state.externalButton = externalButton.init(config.params.buttonSelector, function () { $scope.$apply(function () { _this.validate('bestellen'); }); }, this.state.basketEnabled);
                this.tabNav.setBook(this.book);
                this.export();
                this.registerBeforeUnload();
                this.watchBookChange();
            }
            AppController.prototype.countAutoForms = function () {
                var forms = config.configJson.forms;
                var count = 0;
                for (var _i = 0, forms_1 = forms; _i < forms_1.length; _i++) {
                    var form = forms_1[_i];
                    if (['autotext', 'letters', 'check-all', 'counter'].includes(form.type)) {
                        count++;
                    }
                }
                return count;
            };
            AppController.prototype.export = function () {
                var api = window[config.params.apiName];
                if (!api) {
                    return;
                }
                Object.defineProperty(api, '$q', {
                    value: $q,
                    enumerable: false,
                    writable: false,
                    configurable: false
                });
            };
            AppController.prototype.validate = function (button) {
                return __awaiter(this, void 0, void 0, function () {
                    var formErrors, validator, state, matches_1, tabIndex;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                formErrors = this.$scope.$parentForm.$error;
                                validator = this.formValidator;
                                state = validator.validate(formErrors);
                                Object.assign(this.validated, validator.validated);
                                if (!(state === 'valid')) return [3 /*break*/, 2];
                                track.track({ eventAction: button });
                                return [4 /*yield*/, this.checkProfanity()];
                            case 1:
                                matches_1 = _a.sent();
                                if (matches_1.length) {
                                    $timeout(function () {
                                        _this.showProfanityDialog(matches_1);
                                    });
                                    return [2 /*return*/];
                                }
                                return [3 /*break*/, 3];
                            case 2:
                                this.tabNav.tabs.showInvalidTab();
                                tabIndex = this.tabNav.tabs.getGlobalIndex() + 1;
                                track.track({ eventAction: "fehler_" + tabIndex });
                                _a.label = 3;
                            case 3:
                                $timeout(function () { _this.showValidationDialog(state); });
                                return [2 /*return*/];
                        }
                    });
                });
            };
            AppController.prototype.checkProfanity = function () {
                return __awaiter(this, void 0, void 0, function () {
                    var formsWithProfanityFilter, profanityFilterMatches, _i, _a, tab, _b, _c, subTab, profanityFilterResults, _d, profanityFilterResults_1, result, _e, _f, match, _loop_1, _g, formsWithProfanityFilter_1, form;
                    return __generator(this, function (_h) {
                        switch (_h.label) {
                            case 0:
                                formsWithProfanityFilter = [];
                                profanityFilterMatches = [];
                                for (_i = 0, _a = this.tabNav.tabs; _i < _a.length; _i++) {
                                    tab = _a[_i];
                                    if (tab.tabs.length) {
                                        for (_b = 0, _c = tab.tabs; _b < _c.length; _b++) {
                                            subTab = _c[_b];
                                            formsWithProfanityFilter = formsWithProfanityFilter.concat(subTab.formsWithProfanityFilter);
                                        }
                                    }
                                    else {
                                        formsWithProfanityFilter = formsWithProfanityFilter.concat(tab.formsWithProfanityFilter);
                                    }
                                }
                                return [4 /*yield*/, this.profanityFilter.checkForms(formsWithProfanityFilter, this.book)];
                            case 1:
                                profanityFilterResults = _h.sent();
                                profanityFilterResults = profanityFilterResults.filter(function (result) { return result.matches.length; });
                                if (!profanityFilterResults.length) {
                                    return [2 /*return*/, Promise.resolve([])];
                                }
                                for (_d = 0, profanityFilterResults_1 = profanityFilterResults; _d < profanityFilterResults_1.length; _d++) {
                                    result = profanityFilterResults_1[_d];
                                    for (_e = 0, _f = result.matches; _e < _f.length; _e++) {
                                        match = _f[_e];
                                        profanityFilterMatches.push(match);
                                    }
                                }
                                _loop_1 = function (form) {
                                    if (profanityFilterResults.filter(function (result) { return result.id === form.id; }).length) {
                                        form.showProfanityValidation(true);
                                    }
                                    else {
                                        form.showProfanityValidation(false);
                                    }
                                };
                                for (_g = 0, formsWithProfanityFilter_1 = formsWithProfanityFilter; _g < formsWithProfanityFilter_1.length; _g++) {
                                    form = formsWithProfanityFilter_1[_g];
                                    _loop_1(form);
                                }
                                this.tabNav.tabs.showProfaneTab(profanityFilterResults[0].id);
                                return [2 /*return*/, Promise.resolve(profanityFilterMatches)];
                        }
                    });
                });
            };
            AppController.prototype.showFullPreview = function (full, eventModifier, pageId) {
                if (full === void 0) { full = true; }
                if (!this.state.fullPreview || this.state.screen.fullPreview === full) {
                    return;
                }
                if (full) {
                    this.state.pageBeforeFullscreen = this.preview.getActive().id;
                    var eventAction = 'vollbuch-vorschau';
                    if (!eventModifier && !this.state.navigated) {
                        eventModifier = 'initial';
                    }
                    if (eventModifier) {
                        eventAction = eventAction + " " + eventModifier;
                    }
                    track.track({ eventAction: eventAction }, { eventAction: 'vollbuch-vorschau' });
                }
                else {
                    this.preview.setActive(this.state.pageBeforeFullscreen, false);
                    scroller.scrollTo(appState.screen.isMobile ? '#pb-scroll-form' : '#pb-scroll-top', 0);
                }
                this.state.screen.fullPreview = full;
                resizer.showFullScreen(this.state.screen.fullPreview);
                if (!isNaN(pageId)) {
                    this.preview.setActive(pageId, false);
                }
                else {
                    resizer.resize();
                }
            };
            AppController.prototype.showValidationDialog = function (state) {
                var _this = this;
                var onConfirm = function () {
                    send.toBasket().then(_this.savedToBasket);
                    track.track({ eventAction: 'in den warenkorb' });
                };
                var onCancel = function () {
                    _this.tabNav.tabs.showfirstTab();
                    track.track({ eventAction: 'gestaltung pruefen' });
                };
                var onPreview = function () {
                    var pageID = _this.preview.getFirstPage().id;
                    _this.showFullPreview(true, 'dialog', pageID);
                };
                var onMail = function () {
                    _this.state.loaderAnimation = true;
                    send.toMail().then(function (json) {
                        $timeout(function () {
                            _this.state.loaderAnimation = false;
                            _this.onMailSent(json);
                        });
                    });
                    track.track({ eventAction: 'per email senden' });
                };
                if (state === 'valid' && this.state.sendMail) {
                    state = 'mail';
                }
                switch (state) {
                    case 'required':
                        dialog.show(this.locale.ui.dialogs.required.text, {
                            title: this.locale.ui.dialogs.required.title,
                            buttons: [
                                { label: this.locale.ui.dialogs.required.button.ok }
                            ],
                            type: 'alert'
                        });
                        break;
                    case 'pattern':
                        dialog.show(this.locale.ui.dialogs.pattern.text, {
                            title: this.locale.ui.dialogs.pattern.title,
                            buttons: [
                                { label: this.locale.ui.dialogs.pattern.button.ok }
                            ],
                            type: 'alert'
                        });
                        break;
                    case 'valid':
                        var buttons = this.state.fullPreview ? [
                            { label: this.locale.ui.dialogs.valid.button.cancel, callback: onCancel, style: 'secondary' },
                            { label: this.locale.ui.dialogs.valid.button.preview, callback: onPreview, style: 'secondary', keep: true },
                            { label: this.locale.ui.dialogs.valid.button.ok, callback: onConfirm }
                        ] : [
                            { label: this.locale.ui.dialogs.valid.button.cancel, callback: onCancel, style: 'secondary' },
                            { label: this.locale.ui.dialogs.valid.button.ok, callback: onConfirm }
                        ];
                        dialog.show(this.locale.ui.dialogs.valid.text, {
                            title: this.locale.ui.dialogs.valid.title,
                            buttons: buttons,
                            type: 'success'
                        });
                        break;
                    case 'mail':
                        dialog.show(this.locale.ui.dialogs.mail.text, {
                            title: this.locale.ui.dialogs.mail.title,
                            buttons: [
                                { label: this.locale.ui.dialogs.mail.button.cancel, callback: onCancel, style: 'secondary' },
                                { label: this.locale.ui.dialogs.mail.button.ok, callback: onMail }
                            ],
                            type: 'success'
                        });
                        break;
                    default:
                        dialog.show(this.locale.ui.dialogs.error.text, {
                            title: this.locale.ui.dialogs.error.title,
                            buttons: [
                                { label: this.locale.ui.dialogs.error.button.ok }
                            ],
                            type: 'alert'
                        });
                }
            };
            AppController.prototype.save = function () {
                send.toUrl().then(this.showSaveToUrlDialog);
            };
            AppController.prototype.showProfanityDialog = function (matches) {
                // Remove duplicate entries:
                matches = matches.filter(function (item, index) { return matches.indexOf(item) === index; });
                dialog.show($interpolate(appState.appCtrl.locale.ui.dialogs.profane.text)({ profaneWords: "\"" + matches.join('", "') + "\"" }), {
                    title: this.locale.ui.dialogs.profane.title,
                    buttons: [{ label: this.locale.ui.dialogs.profane.button.ok }],
                    type: 'alert'
                });
            };
            AppController.prototype.savedToBasket = function (json) {
                // TODO: do anything after adding config to basket!? Check for errors!?
            };
            AppController.prototype.onMailSent = function (result) {
                if (result && result.success) {
                    dialog.show(appState.appCtrl.locale.ui.dialogs.mailSuccess.text, {
                        title: appState.appCtrl.locale.ui.dialogs.mailSuccess.title,
                        buttons: [{ label: appState.appCtrl.locale.ui.dialogs.mailSuccess.button.ok }],
                        type: 'success'
                    });
                    this.tabNav.tabs.showfirstTab();
                }
                else {
                    dialog.show(appState.appCtrl.locale.ui.dialogs.mailError.text, {
                        title: appState.appCtrl.locale.ui.dialogs.mailError.title,
                        buttons: [{ label: appState.appCtrl.locale.ui.dialogs.mailError.button.ok }],
                        type: 'alert'
                    });
                }
            };
            AppController.prototype.showSaveToUrlDialog = function (json) {
                var getDate = function () {
                    var date = new Date();
                    var pad = function (num) { return (num < 10 ? '0' : '') + num; };
                    return date.getFullYear() +
                        '-' + pad(date.getMonth() + 1) +
                        '-' + pad(date.getDate()) +
                        ' ' + pad(date.getHours()) +
                        ':' + pad(date.getMinutes()) +
                        ':' + pad(date.getSeconds());
                };
                json.configTime = getDate();
                // TODO: Check for errors!?
                var userLoggedIn = json.userLoggedIn === true;
                var buttons = [{ label: appState.appCtrl.locale.ui.dialogs.saveToUrl.button.cancel, style: 'secondary' }];
                var onConfirm = function () {
                    send.toCollection().then(appState.appCtrl.showSaveToCollectionDialog);
                };
                var shortcut = /Mac/i.test(navigator.userAgent) ? '⌘-C' : 'Strg-C';
                var message = "\n          <p>" + appState.appCtrl.locale.ui.dialogs.saveToUrl.text[0] + "</p>\n          <span class=\"pb-link-name\">" + json.configName + "</span>\n          <span class=\"pb-link-time\">" + json.configTime + "</span>\n          <div class=\"pb-link-wrapper\">\n            <div class=\"pb-link-message-wrapper{{dialogCtrl.success !== null ? ' pb-link-message-fade' : ''}}\">\n              <div class=\"pb-link-message\" ng-if=\"dialogCtrl.success === true\">\n                " + appState.appCtrl.locale.ui.dialogs.saveToUrl.text[2] + "\n              </div>\n              <div class=\"pb-link-message\" ng-if=\"dialogCtrl.success === false\">\n                " + $interpolate(appState.appCtrl.locale.ui.dialogs.saveToUrl.text[3])({ shortcut: shortcut }) + "\n              </div>\n            </div>\n            <div class=\"pb-link-buttons\">\n              <a class=\"pb-link-button pb-link-button-copy\"\n                 href=\"" + json.configLink + "\"\n                 onclick=\"return false\"\n                 ngclipboard\n                 data-clipboard-text=\"" + json.configLink + "\"\n                 ngclipboard-success=\"dialogCtrl.onSuccess(e)\"\n                 ngclipboard-error=\"dialogCtrl.onError(e)\">\n                 <img ng-src=\"" + config.params.base + "img/link-copy.png\" />\n                 " + appState.appCtrl.locale.ui.dialogs.saveToUrl.text[1] + "\n              </a>\n              <a class=\"pb-link-button pb-link-button-mail\"\n                 ng-href=\"mailto:?to=&subject={{'" + $interpolate(appState.appCtrl.locale.ui.dialogs.saveToUrl.text[7])(json) + "' | encodeURIComponent}}&body={{'" + $interpolate(appState.appCtrl.locale.ui.dialogs.saveToUrl.text[8])(json) + "' | encodeURIComponent}}\">\n                 <img ng-src=\"" + config.params.base + "img/link-e-mail.png\" />\n                 " + appState.appCtrl.locale.ui.dialogs.saveToUrl.text[4] + "\n              </a>\n              <a class=\"pb-link-button pb-link-button-whatsapp\"+\n                 target=\"_blank\"\n                 ng-href=\"https://api.whatsapp.com/send/?text={{'" + $interpolate(appState.appCtrl.locale.ui.dialogs.saveToUrl.text[8])(json) + "' | encodeURIComponent}}\">\n                 <img ng-src=\"" + config.params.base + "img/link-whatsapp.png\" />\n                 " + appState.appCtrl.locale.ui.dialogs.saveToUrl.text[5] + "\n              </a>\n            </div>\n          </div>\n          <p>" + appState.appCtrl.locale.ui.dialogs.saveToUrl.text[6] + "</p>\n        ";
                // Temorary disable differentiation of login state
                // if (userLoggedIn) {
                //   buttons.push({
                //     label: appState.appCtrl.locale.ui.dialogs.saveToUrl.button.ok,
                //     callback: onConfirm
                //   });
                //   message += `<p><b>${appState.appCtrl.locale.ui.dialogs.saveToUrl.text[5]}</b></p>`;
                //   message += `<p>${appState.appCtrl.locale.ui.dialogs.saveToUrl.text[6]}</p>`;
                // } else {
                //   message += `<p>${appState.appCtrl.locale.ui.dialogs.saveToUrl.text[7]}</p>`;
                // }
                dialog.show(message, {
                    title: appState.appCtrl.locale.ui.dialogs.saveToUrl.title,
                    buttons: buttons,
                    type: 'success'
                });
            };
            AppController.prototype.showSaveToCollectionDialog = function (json) {
                // TODO: Check for errors!?
                dialog.show("\n            <p>" + $interpolate(appState.appCtrl.locale.ui.dialogs.saveToCollection.text)(json) + "</p>\n          ", {
                    title: appState.appCtrl.locale.ui.dialogs.saveToCollection.title,
                    buttons: [{ label: appState.appCtrl.locale.ui.dialogs.saveToCollection.button.ok }],
                    type: 'success'
                });
            };
            AppController.prototype.watchBookChange = function () {
                var _this = this;
                this.$scope.$watch(function () { return book; }, function (newValue, oldValue) {
                    if (newValue === oldValue) {
                        // Ignore call during initialization
                    }
                    else if (_this.autoForms > 0) {
                        // Do not trigger for autoforms
                        _this.autoForms--;
                    }
                    else {
                        _this.onBookChange(newValue);
                    }
                }, true);
            };
            AppController.prototype.checkReady = function () {
                // TODO: Load templates really associated with first form!
                // Consider app to be ready when directive templates required on first tab have been
                var templates = [
                    'application',
                    'form/form'
                ];
                if (this.book.hasOwnProperty('buchstaben')) {
                    templates.concat([
                        'form/options/letters',
                        'form/options/glyphs'
                    ]);
                }
                else {
                    templates.concat([
                        'form/options/image-switch',
                        'form/options/text',
                        'form/options/radio',
                        'form/options/checkbox',
                        'form/options/color'
                    ]);
                }
                // loaded (i.e. put in template cache)
                return templates.reduce(function (isReady, template) {
                    if (!isReady) {
                        return false;
                    }
                    return !!$templateCache.get(config.params.base + ("templates/" + template + ".html"));
                }, true);
            };
            AppController.prototype.onReady = function () {
                appState.ready = true;
                if (!config.versionMatch) {
                    this.showVersionMismatchDialog();
                }
            };
            AppController.prototype.onBookChange = function (book) {
                appState.saved = false;
                this.saveToLocalStorage(book);
            };
            AppController.prototype.saveToLocalStorage = function (book) {
                var options = { book: config.configJson.id };
                var assignments = config.configJson.localStorage || {};
                assignments = assignments.write || {};
                for (var _i = 0, _a = Object.entries(assignments); _i < _a.length; _i++) {
                    var _b = _a[_i], property = _b[0], value = _b[1];
                    var result = $interpolate(value)(book);
                    if (result) {
                        options[property] = result;
                    }
                }
                this.store.set(options);
            };
            AppController.prototype.registerBeforeUnload = function () {
                var _this = this;
                window.addEventListener('beforeunload', function (evt) {
                    if (!appState.saved) {
                        window.setTimeout(_this.showSaveOnReturnDialog.bind(_this), 100);
                        // Confirmation message
                        var msg = appState.appCtrl.locale.ui.dialogs.beforeUnload.text;
                        evt.returnValue = msg;
                        return msg;
                    }
                });
            };
            AppController.prototype.showVersionMismatchDialog = function () {
                dialog.show(appState.appCtrl.locale.ui.dialogs.versionMismatch.text, {
                    title: appState.appCtrl.locale.ui.dialogs.versionMismatch.title,
                    buttons: [{ label: appState.appCtrl.locale.ui.dialogs.versionMismatch.button.ok }],
                    type: 'warning'
                });
            };
            AppController.prototype.showSaveOnReturnDialog = function () {
                var _this = this;
                var onConfirm = function () {
                    send.toUrl().then(_this.showSaveToUrlDialog);
                };
                dialog.show(appState.appCtrl.locale.ui.dialogs.saveOnReturn.text, {
                    title: appState.appCtrl.locale.ui.dialogs.saveOnReturn.title,
                    buttons: [
                        { label: appState.appCtrl.locale.ui.dialogs.saveOnReturn.button.cancel, style: 'secondary' },
                        { label: appState.appCtrl.locale.ui.dialogs.saveOnReturn.button.ok, callback: onConfirm }
                    ],
                    type: 'warning'
                });
            };
            AppController.prototype.hasFeature = function (key) {
                return this.testFeatures.hasFeature(key);
            };
            return AppController;
        }()),
        controllerAs: 'app'
    };
}
book_1.default.directive('pbApp', ApplicationDirective)
    .service('appState', ApplicationState)
    .config(function ($sceDelegateProvider) {
    $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        'https://*.framily.de/**',
        'https://*.framily.local/**'
    ]);
});
